"use strict";

(function () {
	function r(e, n, t) {
		function o(i, f) {
			if (!n[i]) {
				if (!e[i]) {
					var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
				}var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
					var n = e[i][1][r];return o(n || r);
				}, p, p.exports, r, e, n, t);
			}return n[i].exports;
		}for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
			o(t[i]);
		}return o;
	}return r;
})()({ 1: [function (require, module, exports) {
		"use strict";

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				btn_go_to_checkout: $('.save_data_before_checkout.checkout-button'),
				reset_form_fields_values: $('.reset_form_fields_values'),
				add_product_to_the_cart: $('.add_product_to_the_cart'),
				hide_notification_popup: $('.hide-notification-popup')
			},

			classes: {
				disable: 'disable'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;

				// bind events
				$dom.btn_go_to_checkout.on('click', function () {
					if ($(this).hasClass(classes.disable)) {
						return false;
					}
					$(this).addClass(classes.disable);
					jQuery.ajax({
						url: solis_scriprs.ajax_url,
						type: 'post',
						dataType: "json",
						data: {
							action: 'solis_add_data_to_session',
							form_data: $('form.custom_user_shipping_data').serializeArray(),
							btn_url: $(this).attr('href')
						},
						success: function success(response) {
							window.location.href = response;
						}
					});
					return false;
				});

				$dom.reset_form_fields_values.on('click', function () {
					var $form = $(this).closest('form');
					$form.find('input[type="text"], input[name="state"], input[type="tel"]').val('');
					$form.find('input[type="radio"]').prop('checked', false).removeAttr('checked');
					$form.find('div.js-dd-current').text('State');
				});

				$dom.add_product_to_the_cart.on('click', function () {
					var me = $(this);
					if (me.hasClass(classes.disable)) {
						return false;
					}
					me.addClass(classes.disable);
					jQuery.ajax({
						url: solis_scriprs.ajax_url,
						type: 'post',
						dataType: "json",
						data: {
							action: 'add_product_to_the_cart_action',
							product_id: jQuery(this).data('product-id')
						},
						success: function success(response) {
							for (var id in response['products']) {
								if ($('.price_wrapper_for_product_' + id).length) {
									$('.price_wrapper_for_product_' + id).html(response['products'][id]);
								}
							}
							if ($('span.font-cart .custom-header-cart-count').length) {
								$('span.font-cart .custom-header-cart-count').html(response['cart_count']);
							}
							me.removeClass(classes.disable);
							if ($('.custom-notifications-popup').length) {
								$('.custom-notifications-popup').show();
							}
						}
					});
					return false;
				});

				$dom.hide_notification_popup.on('click', function () {
					$(this).closest('.custom-notifications-popup').hide();
					return false;
				});

				$('.product_type_simple.ajax_add_to_cart').on('click', function () {
					if ($('.custom-notifications-popup').length) {
						$('.custom-notifications-popup').show();
					}
				});

				$(document).ready(function () {

					$('form.form-login').on('submit', function (e) {
						var me = $(this);
						if (me.hasClass(classes.disable)) {
							return false;
						}
						me.addClass(classes.disable);
						var form = me.closest('form');
						form.find('.login-result').html('');
						$.ajax({
							type: 'POST',
							dataType: 'json',
							url: solis_scriprs.ajax_url,
							data: {
								'action': 'ajaxlogin', //calls wp_ajax_nopriv_ajaxlogin
								'username': form.find('#username').val(),
								'password': form.find('#password').val(),
								'security': form.find('#security').val()
							},
							success: function success(data) {
								if (data.loggedin == true) {
									location.reload();
								} else {
									form.find('.login-result').html('<p>' + data.message + '</p>');
								}
								me.removeClass(classes.disable);
							},
							error: function error() {
								me.removeClass(classes.disable);
							}
						});
						e.preventDefault();
					});

					var $form = $('#mc-embedded-subscribe-form-popup');
					if ($form.length > 0) {
						$form.find('input[type="submit"]').bind('click', function (event) {
							var submit_btn = $(this);
							if (submit_btn.hasClass(classes.disable)) {
								return false;
							}
							submit_btn.addClass(classes.disable);
							if (event) {
								event.preventDefault();
							}
							subscribe_user($form);
						});
					}
				});

				function subscribe_user($form) {
					var submit_btn = $form.find('input[type="submit"]');
					jQuery('#mc-embedded-subscribe-popup').val('Sending...');
					jQuery.ajax({
						type: $form.attr('method'),
						url: $form.attr('action'),
						data: $form.serialize(),
						cache: false,
						dataType: 'json',
						contentType: 'application/json; charset=utf-8',
						error: function error(err) {
							jQuery('#subscribe-result').html('<p>Could not connect to the registration server. Please try again later.</p>');
							submit_btn.removeClass(classes.disable);
						},
						success: function success(data) {
							jQuery('#mc-embedded-subscribe-popup').val('Subscribe');
							if (data.result === 'success') {
								// Yeahhhh Success
								var user_email = $form.find('#mce-EMAIL-popup').val();
								var user_name = $form.find('#mce-FNAME-popup').val();
								jQuery('#mce-EMAIL-popup').css('borderColor', '#d8d8d8');
								//jQuery('#subscribe-result').html('<p>Thank you for subscribing. We have sent you a confirmation email.</p>')
								jQuery('#subscribe-result').html('');
								jQuery('#mce-EMAIL-popup').val('');
								jQuery('#mce-FNAME-popup').val('');

								jQuery.ajax({
									url: solis_scriprs.ajax_url,
									type: 'post',
									dataType: "json",
									data: {
										action: 'create_cart_coupon_action',
										user_email: user_email,
										user_name: user_name
									},
									success: function success(response) {
										if (response['status'] == '01') {
											jQuery('#subscribe-result').html('<p>Thank you for subscribing. We have sent you a confirmation email.</p>');
										}
										submit_btn.removeClass(classes.disable);
									}
								});
							} else {
								// Something went wrong, do something to notify the user.
								jQuery('#mce-EMAIL-popup').css('borderColor', '#ff8282');
								jQuery('#subscribe-result').html('<p>' + data.msg.substring(4) + '</p>');
								submit_btn.removeClass(classes.disable);
							}
						}
					});
				};
			}
		};
	}, { "./global": 4 }], 2: [function (require, module, exports) {
		"use strict";

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				animateEl: $('.js-animate')
			},

			classes: {
				visible: 'is-visible'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;

				var windowHeight = Global.$dom.window.height();
				var windowTopPosition = Global.$dom.window.scrollTop();
				var windowBottomPosition = windowTopPosition + windowHeight;

				$dom.animateEl.each(function () {
					var $element = $(this);
					var animationDelay = $element.attr('data-delay');
					if (animationDelay === undefined) {
						animationDelay = 0;
					}

					var elementHeight = $element.outerHeight();
					var elementTopPosition = $element.offset().top + windowHeight / 5;
					var elementBottomPosition = elementTopPosition + elementHeight;

					//check to see if this current container is within viewport
					if (elementBottomPosition >= windowTopPosition && elementTopPosition <= windowBottomPosition) {
						setTimeout(function () {
							$element.addClass(classes.visible);
						}, animationDelay);
					}

					// } else {
					// 	$element.removeClass(classes.visible);
					// }
				});
			}

		};
	}, { "./global": 4 }], 3: [function (require, module, exports) {
		"use strict";

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				ddSel: $('.js-dd-select'),
				ddCurrent: $('.js-dd-current'),
				ddOption: $('.js-dd-option'),
				ddInput: $('.js-dd-input')
			},

			classes: {
				open: 'is-open'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;

				// functions
				function closeDropdown() {
					$dom.ddSel.removeClass(classes.open);
				}

				// bind events
				$dom.ddCurrent.on('click', function (e) {
					e.stopPropagation();
					var $this = $(this);
					var $closestDD = $this.closest($dom.ddSel);
					$dom.ddSel.not($closestDD).removeClass(classes.open);
					$closestDD.toggleClass(classes.open);
				});

				$dom.ddOption.on('click', function () {
					var $this = $(this);
					var ddValue = $this.attr('data-dd-option');
					var ddText = $this.html();
					var $closestDD = $this.closest($dom.ddSel);
					$closestDD.find($dom.ddInput).val(ddValue);
					$closestDD.find($dom.ddCurrent).text(ddText);
					closeDropdown();
				});

				Global.functions.clickOutsideContainer(Global.$dom.body, $dom.ddSel, $dom.ddOption, closeDropdown);

				Global.functions.escKey(closeDropdown);
			}
		};
	}, { "./global": 4 }], 4: [function (require, module, exports) {
		"use strict";

		module.exports = {
			$dom: {
				window: $(window),
				body: $('body')
			},

			vars: {
				windowWidth: window.innerWidth
			},

			functions: {
				escKey: function escKey(callback) {
					$(document).on('keyup', function (e) {
						if (e.keyCode === 27) {
							callback();
						}
					});
				},

				clickOutsideContainer: function clickOutsideContainer(selector, container, closeBtn, callback) {
					selector.on('mouseup', function (e) {
						e.stopPropagation();
						if (!container.is(e.target) && container.has(e.target).length === 0 && !closeBtn.is(e.target)) {
							callback();
						}
					});
				}
			}
		};
	}, {}], 5: [function (require, module, exports) {
		"use strict";

		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				mediaSel: $('.js-media')
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;

				$dom.mediaSel.fancybox({
					caption: function caption(instance, item) {
						var caption = $(this).data('caption') || '';

						if (item.type === 'image') {
							caption = (caption.length ? caption + '<br />' : '') + '<a href="' + item.src + '" target="_blank">Download image</a>';
						}

						return caption;
					}
				});
			}
		};
	}, {}], 6: [function (require, module, exports) {
		"use strict";

		$ = jQuery;
		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				menuBtn: $('.js-menu-btn'),
				menuNav: $('.js-main-nav'),
				menuHasSub: $('.menu-item-has-children')
			},

			classes: {
				open: 'open',
				openMenu: 'menu-open',
				noscroll: 'no-scroll'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;

				// functions
				function closeNav() {
					$dom.menuBtn.removeClass(classes.open);
					$dom.menuNav.removeClass(classes.open);
					Global.$dom.body.removeClass(classes.noscroll);
				}

				if (Global.vars.windowWidth < 768) {
					$dom.menuHasSub.each(function (i, el) {
						$(el).append('<span class="sub-icon font-plus-circle" data-open-sub></span>');
					});
				}

				// bind events
				$dom.menuBtn.on('click', function (e) {
					e.preventDefault();
					$dom.menuBtn.toggleClass(classes.open);
					$dom.menuNav.toggleClass(classes.open);
					Global.$dom.body.toggleClass(classes.noscroll);
				});

				$dom.menuNav.on('click', '[data-open-sub]', function () {
					if (Global.vars.windowWidth < 768) {
						$(this).siblings('.sub-menu').slideToggle();
					}
				});

				Global.functions.clickOutsideContainer($dom.menuNav, $dom.menuNav.children('ul'), $dom.menuBtn, closeNav);

				Global.functions.escKey(closeNav);
			}
		};
	}, { "./global": 4 }], 7: [function (require, module, exports) {
		"use strict";

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				popupInit: $('.js-popup-init'),
				popupSel: $('.js-popup'),
				popupBox: $('.js-popup-box'),
				popupClose: $('.js-popup-close')
			},

			classes: {
				visible: 'is-visible',
				noscroll: 'no-scroll'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;

				// functions
				function closePopup() {
					$dom.popupSel.removeClass(classes.visible);
					Global.$dom.body.removeClass(classes.noscroll);
				}

				// bind events
				$dom.popupInit.on('click', function () {
					var popupID = $(this).data('id');
					$('#popup-' + popupID).addClass(classes.visible);
					Global.$dom.body.toggleClass(classes.noscroll);
				});

				$dom.popupClose.on('click', function () {
					closePopup();
				});

				Global.functions.clickOutsideContainer($dom.popupSel, $dom.popupBox, $dom.popupClose, closePopup);

				Global.functions.escKey(closePopup);
			}
		};
	}, { "./global": 4 }], 8: [function (require, module, exports) {
		"use strict";

		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				html: $('html, body'),
				scrollInit: $('.js-scrollto-init'),
				scrollSec: $('.js-scrollto-section'),
				scrollNavSel: $('.js-nav'),
				scrollToNav: $('.js-scrollto-nav')
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				if ($dom.scrollNavSel.length) {
					var navTop = $dom.scrollNavSel.offset().top;
				}

				$dom.scrollInit.on('click', function () {
					var sectionNum = $(this).attr('data-section');
					var currentSec = $dom.scrollSec.eq(sectionNum - 1);
					var currentSecTop = currentSec.offset().top;
					$dom.html.animate({ scrollTop: currentSecTop }, 600);
				});

				$dom.scrollToNav.on('click', function () {
					$dom.html.animate({ scrollTop: navTop }, 600);
				});
			}
		};
	}, {}], 9: [function (require, module, exports) {
		"use strict";

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				searchInit: $('.js-search-init'),
				searchSel: $('.js-search'),
				searchBox: $('.js-search-box'),
				searchClose: $('.js-search-close')
			},

			classes: {
				open: 'is-visible',
				noscroll: 'no-scroll'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;

				// functions
				function closeSearch() {
					$dom.searchSel.removeClass(classes.open);
					Global.$dom.body.removeClass(classes.noscroll);
				}

				// bind events
				$dom.searchInit.on('click', function () {
					$dom.searchSel.toggleClass(classes.open);
					Global.$dom.body.toggleClass(classes.noscroll);
				});

				$dom.searchClose.on('click', function () {
					closeSearch();
				});

				Global.functions.clickOutsideContainer($dom.searchSel, $dom.searchBox, $dom.searchClose, closeSearch);

				Global.functions.escKey(closeSearch);
			}
		};
	}, { "./global": 4 }], 10: [function (require, module, exports) {
		"use strict";

		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				slider: $('.js-slider')
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;

				// slider
				$dom.slider.slick({
					infinite: true,
					slidesToShow: 3,
					slidesToScroll: 1,
					speed: 1000,
					rows: 2,
					nextArrow: $('.arrow-right'),
					prevArrow: $('.arrow-left'),
					responsive: [{
						breakpoint: 991,
						settings: {
							slidesToShow: 2
						}
					}, {
						breakpoint: 767,
						settings: {
							slidesToShow: 1
						}
					}]
				});
			}
		};
	}, {}], 11: [function (require, module, exports) {
		"use strict";

		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				tab: $('.js-tab'),
				tabContent: $('.js-tab-content')
			},

			classes: {
				active: 'is-active'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;

				$dom.tab.eq(0).addClass(classes.active);

				// bind events
				$dom.tab.each(function (index, el) {
					var $this = $(el);

					$this.on('click', function () {
						$this.addClass(classes.active);
						$dom.tab.not($this).removeClass(classes.active);

						var $activeTabContent = $dom.tabContent.eq(index);
						$activeTabContent.slideDown();
						$dom.tabContent.not($activeTabContent).slideUp();
					});
				});
			}
		};
	}, {}], 12: [function (require, module, exports) {
		"use strict";

		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				initBtn: $('.js-init-toggle'),
				toggleContent: $('.js-toggle-content')
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;

				// bind events
				$dom.initBtn.each(function (index, el) {
					var $this = $(el);

					$this.on('click', function () {
						var currentText = $this.text();
						var activeText = $this.data('text-active');
						var inactiveText = $this.data('text-inactive');

						if (currentText === activeText) {
							$this.text(inactiveText);
						} else {
							$this.text(activeText);
						}

						$dom.initBtn.not($this).text(inactiveText);

						var $activeToggleContent = $dom.toggleContent.eq(index);
						$activeToggleContent.slideToggle();
						$dom.toggleContent.not($activeToggleContent).slideUp();
					});
				});
			}
		};
	}, {}], 13: [function (require, module, exports) {
		(function ($) {
			$(function () {
				// Site Menu
				var menu = require('./_site/menu');
				menu.init();

				// Slick Slider
				var sliders = require('./_site/sliders');
				sliders.init();

				// Tabs
				var tabs = require('./_site/tabs');
				tabs.init();

				// Toggle Visible
				var toggle = require('./_site/toggle-visible');
				toggle.init();

				// Animate Elements
				var animate = require('./_site/animate-el');
				animate.init();

				$(window).trigger('scroll');
				$(window).on('scroll resize', function () {
					animate.init();
				});

				// Search
				var searchPopup = require('./_site/search-popup');
				searchPopup.init();

				// ScrollTo
				var scrollTo = require('./_site/scrollto');
				scrollTo.init();

				// Popup
				var popup = require('./_site/popup');
				popup.init();

				// Media Fancybox
				var mediaFancybox = require('./_site/media-fancybox');
				mediaFancybox.init();

				// Dropdown
				var dropdown = require('./_site/dropdown');
				dropdown.init();

				// Ajax
				var ajax = require('./_site/ajax');
				ajax.init();
			});
		})(jQuery);
	}, { "./_site/ajax": 1, "./_site/animate-el": 2, "./_site/dropdown": 3, "./_site/media-fancybox": 5, "./_site/menu": 6, "./_site/popup": 7, "./_site/scrollto": 8, "./_site/search-popup": 9, "./_site/sliders": 10, "./_site/tabs": 11, "./_site/toggle-visible": 12 }] }, {}, [13]);